import { __rest } from "tslib";
import { TravellerFieldEnum } from '@websky/graphql';
export const getUserSettingsByName = (userSettings, name) => {
    var _a;
    return (_a = userSettings === null || userSettings === void 0 ? void 0 : userSettings.find(value => value.name === name)) === null || _a === void 0 ? void 0 : _a.value;
};
export const mergeTravellerDocuments = (initialDocuments, newDocuments) => ((newDocuments === null || newDocuments === void 0 ? void 0 : newDocuments.length) ? newDocuments : initialDocuments).map(document => {
    const _a = document, { __typename = undefined } = _a, exactdocument = __rest(_a, ["__typename"]);
    return exactdocument;
});
export const mergeLoyaltyCards = (initialLoyaltyCards, newLoyaltyCards) => {
    var _a, _b, _c;
    if (!(newLoyaltyCards === null || newLoyaltyCards === void 0 ? void 0 : newLoyaltyCards.length) && !(initialLoyaltyCards === null || initialLoyaltyCards === void 0 ? void 0 : initialLoyaltyCards.length)) {
        return [];
    }
    return (newLoyaltyCards === null || newLoyaltyCards === void 0 ? void 0 : newLoyaltyCards.length)
        ? newLoyaltyCards
        : [
            {
                airlineCode: (_c = (_b = (_a = initialLoyaltyCards === null || initialLoyaltyCards === void 0 ? void 0 : initialLoyaltyCards[0]) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.find(value => value.type === TravellerFieldEnum.LoyaltyAirline)) === null || _c === void 0 ? void 0 : _c.value,
                cardNumber: initialLoyaltyCards[0].number
            }
        ];
};
export const mergeUserData = (user, newFields) => {
    const { values: userValues, id, documents: userDocuments } = user, userFieldsToApi = __rest(user, ["values", "id", "documents"]);
    const initialDocuments = userDocuments.map((_a) => {
        var { values } = _a, rest = __rest(_a, ["values"]);
        return rest;
    });
    const documents = mergeTravellerDocuments(initialDocuments, newFields.documents);
    const loyaltyCards = mergeLoyaltyCards(userFieldsToApi.loyaltyCards, newFields.loyaltyCards);
    if ('__typename' in userFieldsToApi) {
        delete userFieldsToApi.__typename;
    }
    return Object.assign(Object.assign(Object.assign({}, userFieldsToApi), newFields), { documents,
        loyaltyCards });
};
